import React from 'react';
import { Grid, Typography } from '@material-ui/core';

import { useStyles } from './styles';
import { GeneralNotificationsProps } from './types';
import NotificationRows from './NotificationRows';

const GeneralNotifications: React.FC<GeneralNotificationsProps> = ({
  title,
  notifications,
  handleOpenEdit,
  handleChangePermissions,
  useTypeForText,
}) => {
  const styles = useStyles();

  return (
    <>
      <Grid className={styles.notificationBlock}>
        <Typography variant="h2" className={styles.notificationBlockTitle}>
          {title}
        </Typography>
        <NotificationRows
          notifications={notifications}
          handleOpenEdit={handleOpenEdit}
          useTypeForText={useTypeForText}
          handleChangePermissions={handleChangePermissions}
        />
      </Grid>
    </>
  );
};

export default GeneralNotifications;
